import { UnorderedList } from '@bnnvara/lists';
import { Text } from '@bnnvara/typography';
import PropTypes from 'prop-types';
import React from 'react';

const NoSearchResults = ({ query }) => (
  <React.Fragment>
    <Text>
      Hmm, dat is gek. Deze zoekterm - <strong>{query}</strong> - lijkt geen
      resultaten op te leveren.
    </Text>
    <UnorderedList>
      <li>Zijn alle woorden goed gespeld?</li>
      <li>
        Probeer dan een algemenere zoekterm óf probeer een andere zoekterm.
      </li>
    </UnorderedList>
  </React.Fragment>
);

NoSearchResults.propTypes = {
  query: PropTypes.string.isRequired,
};

export default NoSearchResults;
